import { takeEvery, put, call } from "redux-saga/effects";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";
import * as actionTypes from "./actionTypes";
import * as actionCreators from "./actionCreators";

const superAdminRoute = endpoints[endpointTypes.SUPER_ADMIN];

export function* createFormlayoutJSON(action) {
    const endpoint = superAdminRoute.endpoints.createFormlayoutJSON(action.payload.contractorId);
    
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(actionCreators.createFormlayoutJSONSuccess(response.data));
        } else {
            yield put(actionCreators.createFormlayoutJSONFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(actionCreators.createFormlayoutJSONFailure(err));
    }
}

export function* refreshRedisCache(action) {
    const endpoint = superAdminRoute.endpoints.refreshRedisCache();
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(actionCreators.refreshRedisCacheSuccess(response.data));
        } else {
            yield put(actionCreators.refreshRedisCacheFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(actionCreators.refreshRedisCacheFailure(err));
    }
}

export function* refreshActionScopes(action) {
    const endpoint = superAdminRoute.endpoints.refreshActionScope();
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(actionCreators.refreshActionScopesSuccess(response.data));
        } else {
            yield put(actionCreators.refreshActionScopesFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(actionCreators.refreshActionScopesFailure(err));
    }
}

export function* refreshPropertyManagerJson(action) {
    const endpoint = superAdminRoute.endpoints.refreshPropertyManagerJson();
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(actionCreators.refreshPropertyManagerJsonSuccess(response.data));
        } else {
            yield put(actionCreators.refreshPropertyManagerJsonFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(actionCreators.refreshPropertyManagerJsonFailure(err));
    }
}

export function* apiDeepHealthCheck(action) {
    const endpoint = superAdminRoute.endpoints.apiDeepHealthCheck();
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(actionCreators.apiDeepHealthCheckSuccess(response.data));
        } else {
            yield put(actionCreators.apiDeepHealthCheckFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(actionCreators.apiDeepHealthCheckFailure(err));
    }
}

export function* superAdminWatcher() {
    yield takeEvery(actionTypes.CREATE_FORMLAYOUT_JSON, createFormlayoutJSON);
    yield takeEvery(actionTypes.REFRESH_REDIS_CACHE, refreshRedisCache);
    yield takeEvery(actionTypes.REFRESH_ACTION_SCOPES, refreshActionScopes);
    yield takeEvery(actionTypes.REFRESH_PROPERTY_MANAGER_JSON, refreshPropertyManagerJson);
    yield takeEvery(actionTypes.API_DEEP_HEALTH_CHECK, apiDeepHealthCheck);
}